export default __webpack_public_path__ + "static/media/programmingColor.2bef200d.png";